<div class="payment-link-dialog">
  <div class="payment-link-dialog__header">
    <h2 class="payment-link-dialog__title">Payment Link Created</h2>
    <p class="payment-link-dialog__subtitle">Share the URL with your client to receive payment.</p>
  </div>

  <div class="payment-link-dialog__body">
    <div class="payment-link-dialog__link-container">
      <span class="payment-link-dialog__link-input">{{ linkUrl }}</span>
      <lib-button
        *ngIf="!copySuccess"
        [type]="'Tertiary'"
        content="Icon + Text"
        [label]="'Copy'"
        [icon]="copyIcon"
        (click)="copyLink()"
      >
        <ng-template #copyIcon>
          <i fill="#FFFFFF" class="icon copy-blue"></i>
        </ng-template>
      </lib-button>
      <lib-button
        *ngIf="copySuccess"
        [customColor]="'#858EA3'"
        [type]="'Tertiary'"
        content="Icon + Text"
        [label]="'Copied'"
        [icon]="copyIcon"
        (click)="copyLink()"
      >
        <ng-template #copyIcon>
          <i class="icon check"></i>
        </ng-template>
      </lib-button>
    </div>
  </div>

  <div class="payment-link-dialog__footer">
    <lib-button type="Primary" label="Close" (onClick)="close()" />
  </div>
</div>
